var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.link)?_c('a',{attrs:{"href":_vm.link,"target":"_blank"}},[_c('b-icon-box-arrow-up-right',{staticClass:"mr-1",attrs:{"variant":"primary"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }